import { connect } from 'react-redux';
import { closeModal } from 'components/ReduxModal';
import Security from '../components/Security';

export default connect(null, { closeModal })(Security);
